/// <amd-module name="Wit/DeliveryPlans/Common/Components/PlanNameAndDescriptionInput" />

import * as React from "react";
import { IObservableValue } from "VSS/Core/Observable";
import { TextField } from "VSSUI/TextField";
import * as Resources from "Wit/DeliveryPlans/Resources";

export interface PlanNameAndDescriptionInputProps {
    /**
     * Classname to be applied
     */
    className?: string;

    /**
     * Description of the plan
     */
    description: IObservableValue<string>;

    /**
     * Indicates if the controls should be disabled
     */
    disabled?: boolean;

    /**
     * Name of the plan
     */
    name: IObservableValue<string>;

    /**
     * Set a dirty flag based on the current inputs
     */
    setIsDirty?: (currentDescription: string, currentName: string) => void;

    /**
     * Set a valid flag based on current inputs
     */
    setIsValid?: (currentDescription: string, currentName: string) => void;
}
export namespace PlanNameAndDescriptionConstants {
    export const nameTextFieldClass = "name-text-field";
    export const nameTextFieldClassSelector = `.${nameTextFieldClass}`;
}

export const PlanNameAndDescriptionInput = (props: PlanNameAndDescriptionInputProps) => {
    const { className, description, disabled, name, setIsDirty, setIsValid } = props;
    return (
        <div className={className}>
            <TextField
                autoFocus
                className={PlanNameAndDescriptionConstants.nameTextFieldClass}
                disabled={disabled}
                label={getRequiredLabel(Resources.WizardNameLabel)}
                onChange={(event: any, value) => {
                    name.value = value;
                    setIsDirty && setIsDirty(description.value, name.value);
                    setIsValid && setIsValid(description.value, name.value);
                }}
                placeholder={Resources.WizardPlanNamePlaceholder}
                required
                value={name}
            />
            <TextField
                autoAdjustHeight
                className="description-text-field"
                disabled={disabled}
                label={Resources.WizardDescriptionLabel}
                multiline
                onChange={(event: any, value) => {
                    description.value = value;
                    setIsDirty && setIsDirty(description.value, name.value);
                    setIsValid && setIsValid(description.value, name.value);
                }}
                placeholder={Resources.WizardPlanDescriptionPlaceholder}
                value={description}
            />
        </div>
    );
};

const getRequiredLabel = (label: string) => (
    <div className="flex-row">
        <div className="flex-grow">{label}</div>
        <div className="secondary-text">{Resources.RequiredLabel}</div>
    </div>
);
